// extracted by mini-css-extract-plugin
export default {"content":"UseCase1_content__borB-","title":"UseCase1_title__lUJTe","paragraph":"UseCase1_paragraph__0k5Jx"};